/* istanbul ignore next */
import { awBffServerSettings, EnvType } from '@blk/aw-api-clients';

const SENSITIVE_DATA_PARSER_API_PATH = 'sensitive-data-parser/parser.js';

export function loadSensitiveDataParserScript(configurationDirectory: string | undefined) {
  try {
    const envType = awBffServerSettings?.getEnvTypeFn ? awBffServerSettings.getEnvTypeFn() : EnvType.DEFAULT;
    const appName = 'aw-bff' + (envType === EnvType.BETA || envType === EnvType.UAT ? `_${envType}` : '');
    const head = document.getElementsByTagName('head')[0];
    let js = document.createElement('script');
    js.type = 'text/javascript';
    js.src = `/${appName}/${SENSITIVE_DATA_PARSER_API_PATH}${
      configurationDirectory ? `?configurationDirectory=${encodeURIComponent(configurationDirectory)}` : ''
    }`;
    head?.appendChild(js);
  } catch (error) {
    console.error('Tried and fail to load sensitive data parser script');
    console.error(error);
  }
}
